import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/guards/auth.guard';

const routes: Routes = [
 
  {
  path:'auth',
  loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  canLoad:[AuthGuard],canActivate:[AuthGuard]
  },
  
  {
  path:'o',
  loadChildren: () => import('./sucursales/sucursales.module').then(m => m.SucursalesModule)
  }, 
  {
  path:'home',
  loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  }, 
  {
    path:'**',
    redirectTo : 'o'
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
